import { render, staticRenderFns } from "./notifications-tip.vue?vue&type=template&id=27c03d16&scoped=true&"
import script from "./notifications-tip.vue?vue&type=script&lang=js&"
export * from "./notifications-tip.vue?vue&type=script&lang=js&"
import style0 from "./notifications-tip.vue?vue&type=style&index=0&id=27c03d16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c03d16",
  null
  
)

export default component.exports